import React, { useEffect, useState } from 'react'
import util from '../../util/util'
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min'
import { Col, message, Row, Spin } from 'antd'
import ActionCaseTable from './actionCase.table'

import ApolloClientService from '../../services/apolloclient.service'
import { connect } from 'react-redux'
import { ActionCaseBar } from './actionCase.action'
import CaseFilter from './actionCase.filter'
import { constants } from '../../constants'
import { isNewActionCase } from '../../store/action/actioncases.action'
var { ROLE } = constants
const apolloClientService = new ApolloClientService()

function ActionCase(props) {
  useEffect(() => {
    if (props?.company?._id) {
      props.isNewActionCase(null, null, props?.company?._id)
    }
  }, [props?.company?._id])
  const [actionCaseObject, setActionCaseObject] = useState({
    actionCaseList: [],
    totalCount: 0,
  })
  const [filterData, setFilterData] = useState(null)

  return props.token === undefined ? (
    <Redirect to='/login' />
  ) : (
    <>
      <Spin spinning={props.isLoading}>
        <Row type='flex' className='patientRow'>
          <Col span={24} flex='auto'>
            <CaseFilter setFilterData={setFilterData} />
            <ActionCaseBar
              hcId={
                props.profile?.user?.role == ROLE.COMPANY_HEALTHCOACH
                  ? props.profile?.user._id
                  : ''
              }
              actioncases={props.actioncases}
            />
            <ActionCaseTable />
          </Col>
        </Row>
      </Spin>
    </>
  )
}

const mapStateToProps = (state) => {
  console.log('state --------->> ', state)

  return {
    actioncases: state.actioncase,
    isLoading: state.actioncase.isLoading,
    token: util.verifyToken(state.profile.token),
    company: state.profile.company,
    profile: state.profile,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    isNewActionCase: (customer, surgeonId, companyId) =>
      dispatch(isNewActionCase(customer, surgeonId, companyId)),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ActionCase)
